export enum AgTechQueryParam {
  SeasonName = "Name",
  StateIds = "state.id",
  CountryIds = "country.id",
  PageSize = "PageSize",
  UserGroupName = "userGroup.name",
  Status = "Status",
  Pending = "Pending",
  OrderBy = "OrderBy",
  SortOrder = "SortOrder",
  Brand = "Brand",
  Crops = "Crop",
  Name = "Name",
  Team = "Team",
  IsTreatmentExist = "IsTreatmentExist",
  RandomizationType = "RandomizationType",
  minRM = "minRM",
  maxRM = "maxRM",
  Season = "Season",
  User = "User",
  userType = "userType",
  retailer = "Retailer",
  RetailerId = "retailerId",
  NameExactMatch = "NameExactMatch",
  RegionId = "region.id",
  RegionSeasonCode = "region.season",
  Forced = "Forced",
  CombineWithId = "CombineWithId",
  TrialName = "TrialName",
  AllReps = "AllReps",
  PlotNumber = "plotNumber",
  ExcludeIds = "ExcludeIds",
  Locked = "Locked",
  Active = "Active",
  InActive = "Inactive",
  Id = "Id",
  RepNumber = "RepNumber",
  DemoTrialId = "DemoTrialId",
  InventoryName = "InventoryName",
  minRm = "minRm",
  maxRm = "maxRm",
  Location = "Location",
  AttributeTypeName = "AttributeTypeName",
  AttributeTypeNames = "AttributeTypeNames",
  Names = "Names",
  DemoType = "demoType",
  DemoSubType = "demoSubType",
  CropCode = "cropCode",
  IncludeNullCrop = "includeNullCrop",
  ExcludeSeason = "ExcludeSeason",
  TreatmentName = "TreatmentName",
  TreatmentList = "TreatmentList",
  TrialList = "TrialList",
  Resource = "Resource",
  CropId = "cropId",
  SeasonStageName = "SeasonStageName",
  TrialNames = "TrialNames",
  ProtocolID = "ProtocolID",
  TimingName = "TimingName",
  LocationID = "LocationId",
  LocationIDs = "LocationIds",
  DragCopyDate = "DragCopyDate",
  Crop = "Crop",
  ResourceType = "ResourceType",
  ResourceIds = "ResourceIds",
  SortOrderDesc = "Desc",
  BucketName = "bucketName",
  Filler = "Filler",
  TrialIds = "TrialIds",
  isFiller = "isFiller",
  Ag2AgId = "Ag2AgId",
  Ids = "Ids",
  SeasonCode = "seasonCode",
  Print = "Print",
  DatePrinted = "DatePrinted",
  ThenBys = "ThenBys",
  LocId = "LocId",
  AllLocations = "AllLocations",
  Type = "Type",
  FieldJournalId = "fieldJournalId",
  ProductName = "productName",
  Filter = "filter",
  RepIds = "RepId",
  TrialId = "TrialId",
  Treatment = "treatment",
  IsPlacedRep = "isPlacedRep",
  FieldBookId = "fieldBookId",
  Code = "Code",
  TreatmentComboId = "treatmentComboId",
  MembersAg2AgId = "Members.Ag2AgId",
  Range = "Range",
  Row = "Row",
  AttributesSeed = "Attributes.C_NUM_SEED",
  AttributesPackets = "Attributes.C_NUM_PACKETS",
  RepStatus = "repStatus",
  ImageType = "ImageType",
  C_CHECK = "C_CHECK",
  Product_Crop_Code = "crop.code",
  CommonAttributes = "CommonAttributes",
  ModuleName = "moduleName",
  CropNameKey = "Crop.Name",
  CropTypeKey = "CropType.Name",
  IsDemo = "isDemo",
  InventoryId = "inventoryId",
  EntryNumber = "entryNumber",
  C_DEMO_TYPE = "C_DEMO_TYPE",
  C_DEMO_SUB_TYPE = "C_DEMO_SUB_TYPE",
  IR_ScanDate = "Sample Submission Date",
  LabBook_Template_Sample_Date = "Date",
  LabBook_External_Sample_Date = "Lab Report Date",
  Sequence = "sequence",
  LineOfBusiness = "lineOfBusiness",
  C_LINE_OF_BUSINESS = "C_LINE_OF_BUSINESS",
  C_TREATMENT = "C_TREATMENT",
  TrialExperimentId = "TrialExperimentId",
  RetailerIds = "retailerId",
  AnalysisState = "AnalysisState",
  RepAnalysisState = "RepAnalysisState",
  PrintGreenPacket = "PrintGreenPacket",
  C_BLOCK_NAME = "C_BLOCK_NAME",
  Attributes_C_BLOCK_NAME = "Attributes.C_BLOCK_NAME",
  Attributes = "Attributes",
  BookType = "bookType",
  Seller = "Seller",
  Fields = "Fields",
  All = "all",
  CropNames = "cropnames",
  No_Of_Copies="numberOfCopies",
  No_Of_Copies_All="numberOfCopiesForAll",
  StateId="stateId",
  CountyId="countyId",
  State="state",
  County="county",
  Region="region",
  IsRepExist ="isRepExist",
  XPlaceholder="xPlaceholder",
  TSW = "tsw",
  C_DATE_PRINTED = "C_DATE_PRINTED",
  Published = "Published",
  ExportType = "ExportType",
  RetailerName = "RetailerName",
  HarvestMethod = "C_Harvest_Method",
  IsDemoTrial = "IsDemo",
  Contract= "Contract",
  TrialSubmitted = "Trial Submitted",
  DataBlessed = "Data Blessed",
  TrialType = "TrialType",
  TrialClassification = "TrialClassification",
  CountryCode = "CountryCode",
  Module = "module",
  TRIAL_CLASSIFICATION_TYPE = "C_TRIAL_CLASSIFICATION_TYPE",
  AttributeType = "attributeType",
  EnabledForOnFarm = "EnabledForOnFarm",
  Longitude = "Longitude",
  Latitude = "Latitude",
  Context = "context",
  Rep = "rep",
  WorkOrderSampleId = "Work Order Sample Id",
  SampleNo = "Sample No.",
  Commercial = "Commercial",
  OnFarm = "onfarm",
  FilterSchemaName = "FilterSchemaName",
  C_SEEDCARE_TREATMENT = "C_SEEDCARE_TREATMENT",
  C_STAGE = "C_STAGE",
  C_TYPE = "C_TYPE",
  AppTypes = "AppTypes",  //application catalog - application stage ID
  YieldType="yieldType",
  isDirty = "isDirty",
  Category = "category",
  ReportNames = "reportNames",
  TrialInProgress = "Trial In Progress",
  Deleted = "Deleted",
  PlotNum="Plot Number",
  Fixed_Column = "fixed_column",
  Column = "column",
  Hybrid = "hybrid",
  NameMapping = "nameMapping",
  GroupName= "groupName",
  TreatmentProduct = "treatmentProduct",
  ProductDevelopment = "productDevelopment",
  MarketSupport = "marketSupport",
  Agronomic = "agronomic",
  Seed = "seed",
  Quantity = "quantity",
  HarvestPlotNum = "plotNum",
  Entry = "entry",
  EntryPerTreatment = "entryTreatment",
  TrialClassificationType = "trialClassificationType",
  Croplan = "croplan",
  Armor = "armor"
}
